import { createAction } from '@reduxjs/toolkit';
import { produce } from 'immer';

import type { RootState as ProjectionState } from '@polyai/stream/store';
import { sliceReducers } from '@polyai/stream/store';

import type { RootState } from 'reduxStore';

const PREFIX = 'projection';

export const hydrateProjection = createAction<{
  projection: ProjectionState;
  sequenceId: number;
}>(`${PREFIX}/hydrate`);

export const rollBackProjection = createAction<{
  projection: ProjectionState;
}>(`${PREFIX}/rollBack`);

export const applyHydration = (
  state: RootState,
  projection: ProjectionState,
) => {
  const keys = Object.keys(sliceReducers) as Array<keyof typeof sliceReducers>;

  return produce(state, draft => {
    if (!draft) {
      return;
    }

    for (const key of keys) {
      if (key in draft && key in projection) {
        delete draft[key];
        draft[key] = projection[key] as any;
      }
    }
  });
};
